import Divider from './Divider';

export { default as Divider } from './Divider';

export default Divider;
